import request from "../../utils/request";

export function doGetAllGroups(params) {
  return request("/groups", {
    method: "GET",
    params,
  });
}

export function doCreateGroup(params) {
  return request("/groups", {
    method: "POST",
    data: params,
  });
}

export function doUpdateGroup(params) {
  return request(`/groups/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDeleteGroup(id) {
  return request(`/groups/${id}`, {
    method: "DELETE",
  });
}

export function doUpdateGroupInviteEmail(params) {
  return request(`/groups/${params.id}/invite-email`, {
    method: "POST",
    data: params,
  });
}

export function doUpdateGroupDisInviteEmail(params) {
  return request(`/groups/${params.id}/disinvite-email`, {
    method: "POST",
    data: params,
  });
}

export function doGetGroupInviteEmails(id) {
  return request(`/groups/${id}/invite-emails`, {
    method: "GET",
  });
}

export function doGroupAcceptInvite(code) {
  return request(`/groups/${code}/accept-invite`, {
    method: "GET",
  });
}

export function doOffGroupInviteEmails(params) {
  return request(`/groups/${params.id}/turn-off-invite`, {
    method: "POST",
    data: params,
  });
}

export function doGroupGetDetailCode(code) {
  return request(`/groups/${code}/view-invite-code`, {
    method: "GET",
  });
}
